export const ROUTES = {
  login: '/:group',
  resetPassword: '/:group/reset/:token',
  forgottenPassword: '/:group/forgotten-password',
  registerQuery: '/:group/register-query',
  promotions: {
    root: '/:group/promotions',
    new: '/:group/promotions/new',
    edit: '/:group/promotions/:promotionId/edit',
    copy: '/:group/promotions/:promotionId/copy',
  },
  promotionCode: {
    new: '/:group/promotion-code/new',
    edit: '/:group/promotion-code/:id/edit',
    copy: '/:group/promotion-code/:id/copy',
  },
  mags: '/:group/mags',
  profile: '/:group/me',
  forum: '/:group/forum',
  calendar: '/:group/calendar',
  pharmacies: '/:group/pharmacies',
  pharmaciesAffiliations: '/:group/pharmacies-affiliations',
  blog: {
    root: '/:group/blog',
    edit: '/:group/blog/edit',
  },
  settings: '/:group/settings',
  campaigns: {
    root: '/:group/campagnes',
    form: '/:group/campagnes/form',
    detail: '/:group/campagnes/:campaignId',
    report: '/:group/campagnes/:campaignId/rapport',
  },
  career: {
    root: '/:group/carrieres',
    new: '/:group/carrieres/new',
    edit: '/:group/carrieres/edit',
    copy: '/:group/carrieres/copy',
  },
  extranet: {
    banners: '/:group/extranet/banners',
    staff: '/:group/extranet/staff',
    partners: {
      root: '/:group/extranet/partners',
      form: '/:group/extranet/partners/form',
    },
    tools: {
      root: '/:group/extranet/tools',
      form: '/:group/extranet/tools/form',
    },
    events: {
      root: '/:group/extranet/events',
      form: '/:group/extranet/events/form',
    },
    actus: {
      root: '/:group/extranet/actus',
      form: '/:group/extranet/actus/form',
    },
    newsletters: '/:group/extranet/newsletters',
    agreements: {
      mandatory: {
        root: '/:group/extranet/agreements/mandatory',
        form: '/:group/extranet/agreements/mandatory/form',
      },
      priority: {
        root: '/:group/extranet/agreements/priority',
        form: '/:group/extranet/agreements/priority/form',
      },
      recommended: {
        root: '/:group/extranet/agreements/recommended',
        form: '/:group/extranet/agreements/recommended/form',
      },
    },
    actusLabo: {
      root: '/:group/extranet/actus-labo',
      form: '/:group/extranet/actus-labo/form',
    },
    directory: {
      root: '/:group/extranet/directory',
      form: '/:group/extranet/directory/form',
    },
    faq: '/:group/extranet/faq',
    medias: '/:group/extranet/medias',
    tasks: {
      root: '/:group/extranet/tasks',
      form: '/:group/extranet/tasks/form',
      detail: '/:group/extranet/tasks/:id',
    },
    settings: '/:group/extranet/settings',
  },
  communication: '/:group/communication',
  staticContents: '/:group/contenus-statiques',
  valwinNews: '/:group/valwin-news',
  admin: {
    root: '/:group/admin',
    groups: {
      root: '/:group/admin/groups',
      add: '/:group/admin/groups/add',
      detail: '/:group/admin/groups/:pharmacyGroupId',
      features: '/:group/admin/groups/:pharmacyGroupId/features',
      infos: '/:group/admin/groups/:pharmacyGroupId/infos',
      pharmacies: '/:group/admin/groups/:pharmacyGroupId/pharmacies',
    },
    pharmacies: {
      root: '/:group/admin/pharmacies',
      add: '/:group/admin/pharmacies/add',
      supportAccounts: '/:group/admin/pharmacies/support-accounts',
      features: '/:group/admin/pharmacies/:pharmacyId/features',
      configuration: '/:group/admin/pharmacies/:pharmacyId/configuration',
      pharmacists: {
        root: '/:group/admin/pharmacies/:pharmacyId/pharmacists',
        add: '/:group/admin/pharmacies/:pharmacyId/pharmacists/add',
      },
    },
    content: {
      linings: '/:group/admin/content/linings',
      services: '/:group/admin/content/services',
      specialities: '/:group/admin/content/specialities',
      pharmacies: '/:group/admin/content/pharmacies',
      videos: '/:group/admin/content/videos',
      tips: '/:group/admin/content/tips',
      forms: '/:group/admin/content/forms',
      formsEdit: '/:group/admin/content/forms-edit',
    },
  },
} as const;
